<template>
  <div>
    <the-message
      v-for="message in messages"
      :key="`${message.title}${message.text}`"
      :title="showTitle ? message.title : null"
      :text="message.text"
      :severity="getSeverity(message.level)"
      class="message"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'

// Props
const props = defineProps({
  app: {
    type: String,
    required: true,
  },

  language: {
    type: String,
    required: true,
  },

  baseUrl: {
    type: String,
    required: true,
  },

  platform: {
    type: String,
    default: 'others',
  },

  showTitle: {
    type: Boolean,
    default: false,
  },

  fetchMessages: {
    type: Function,
    default: payload => {
      if (window.fetch) {
        //@todo check response.json() error
        return window.fetch(`${payload.serviceUri}?platform=${payload.platform}`).then(response => response.json())
      } else {
        console.error("Can't fetch notifications from" + payload.serviceUri)
      }
    },
  },
})

// Data
const messages = ref([])

// Computed
const serviceUri = computed(() => {
  return `${props.baseUrl}bin/sanitas-system-notification.${props.language}.dvp.json`
})

// Lifecycle hooks
onMounted(() => {
  call()
})

// Methods
function call() {
  const payload = {
    serviceUri: serviceUri.value,
    platform: props.platform,
  }
  props
    .fetchMessages(payload)
    .then(response => {
      if (response && response.notifications) {
        messages.value = response.notifications
      }
    })
    .catch(error => console.error(error))
}

function getSeverity(level) {
  switch (level) {
    default:
    case 'INFORMATION':
      return 'info'

    case 'ERROR':
      return 'error'

    case 'WARNING':
      return 'warning'

    case 'SUCCESS':
      return 'success'
  }
}
</script>

<style scoped>
.message {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
